<template>
  <TableList
    v-rect-loading="loading"
    class="source-channel-page"
    row-key="id"
    noAction
    :title="$t(`${i18nPrefix}.tab.channelManagement`)"
    :listData="sourceChannelList"
    :tableColumns="tableColumns"
    :pagination="pagination"
    @create="handelCreateChannel"
    @pagination-change="handlePaginationChange"
  >
    <template #filter>
      <div class="header-status">
        <span class="status-select">
          <el-select v-model="selectedStatus" @change="handleStatusSelect">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
      </div>
      <div class="header-search">
        <el-input
          v-model="keyword"
          class="search-input"
          clearable
          :title="$t(`${i18nPrefix}.placeholder.search`)"
          :placeholder="$t(`${i18nPrefix}.placeholder.search`)"
          @input="handleKeywordsChange"
        >
        </el-input>
      </div>
    </template>
    <template #status="{ data, row }">
      <el-switch :value="!data" @change="onStatusChange($event, row)"></el-switch>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { mapActions, mapGetters } from 'vuex'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TableList
  },
  props: {

  },
  data () {
    return {
      i18nPrefix: 'admin.company.sourceChannelManagement',
      loading: false,
      sourceChannelList: [],
      selectedStatus: 0,
      keyword: null,
      keywordsSearchDebounce: null,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    account () {
      return this.getCurrentAccount()
    },
    tableColumns () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.affiliatedCompany`),
          dataKey: 'rootCompanyName',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.chineseName`),
          dataKey: 'cn_name',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.englishName`),
          dataKey: 'name',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'is_disabled',
          slotName: 'status',
          width: 20
        }
      ]
    },
    statusList () {
      return [
        { value: 0, label: this.$t(`${this.i18nPrefix}.label.all`) },
        { value: 1, label: this.$t(`${this.i18nPrefix}.label.enable`) },
        { value: 2, label: this.$t(`${this.i18nPrefix}.label.disable`) }
      ]
    }
  },
  created () {
    this.loadSourceChannelList()
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('sourceCode', ['getSourceChannelList', 'updateSourceChannelStatus']),
    async loadSourceChannelList (reload) {
      if (reload) {
        this.pagination.page = 1
        this.pagination.total = 0
      }
      const params = {
        status: this.selectedStatus,
        company_id: this.account.root_company_id,
        page: this.pagination.page,
        page_size: this.pagination.pageSize,
        keyword: this.keyword
      }
      this.loading = true
      try {
        const resp = await this.getSourceChannelList(params)
        if (resp && resp.result) {
          const channelList = _.map(resp.result, item => addI18nProperty(item, 'rootCompanyName', 'root_company.cn_name', 'root_company.name'))
          this.sourceChannelList = channelList
          this.pagination.total = resp.total
        }
      } finally {
        this.loading = false
      }
    },
    async onStatusChange (status, row) {
      const data = { ...row }
      data.is_disabled = !status
      this.loading = true
      try {
        const resp = await this.updateSourceChannelStatus(data)
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
          row.is_disabled = resp.is_disabled
        }
      } finally {
        this.loading = false
      }
    },
    handelCreateChannel () {
      this.$router.push({ path: '/v-admin/source-channel/management/channel/add', query: this.$route.query })
    },
    handleStatusSelect () {
      this.loadSourceChannelList(true)
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.handleSearch, 500)
      }
      this.keywordsSearchDebounce()
    },
    handleSearch () {
      this.loadSourceChannelList(true)
    },
    handlePaginationChange () {
      this.loadSourceChannelList()
    }
  },
  watch: {
    $route: {
      handler () {
        this.loadSourceChannelList(true)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.source-channel-page {
  padding: 0;

  .header-status {
    display: inline-block;
    vertical-align: middle;

    .text {
      margin-right: 10px;
      display: inline-block;
      vertical-align: middle;
    }

    .status-select {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .header-search {
    ::v-deep {
      .el-input__inner {
        border: 1px solid #c0c4cc;
      }

      .el-input-group__append {
        border-left: none;
        padding: 0 5px;
        background-color: #fff;
      }
    }

    .icon-search {
      cursor: pointer;
      font-size: 18px;
    }
  }
}
</style>
